import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { initConfig } from './configHelper';

initConfig().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <App/>
    </React.StrictMode>,
    document.getElementById('root')
  );
});
